module.exports = __webpack_public_path__ + "img/camera_small_close_grey.8c036eae.svg";